module.exports = __webpack_public_path__ + "static/img/you.a48b21a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/you.png
// module id = 118
// module chunks = 180